import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import { withSnackbar } from "notistack";
import { useHistory } from "react-router";
import { formIsComplete } from "../utils";
import {
  CREATE_PATIENT_STEPS,
  INIT_CREATE_PATIENT_FORM_STATE,
} from "../utils/constants";
import { useNewPatientContext } from "../store/NewPatientContextProvider";
import { setNewPatient, setPatientToInit } from "../store/action-reducers";
import { v4 as uuidv4 } from "uuid";
import SaveIcon from "@mui/icons-material/Save";
import { createUser, editPatient } from "../api/api";
import { useAuthUser } from "../store/AuthUserContextProvider";
import {
  PatientDetailsForm,
  EmploymentDetailsForm,
  MedicalAidDetailsForm,
  DocumentsForm,
} from "../components/create-patient/forms";
import { useDataLists } from "../store/DataListsContextProvider";
import { medicalAidNames } from "../utils/constants";

function CreatePatient(props) {
  const history = useHistory();
  const { authUser } = useAuthUser();
  const [isSaving, setSaving] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const { lists } = useDataLists();
  const { newPatient, newPatientDispatch } = useNewPatientContext();
  const EDITING_EXISTING_USER = Boolean(newPatient.PatientDetails.Email);
  console.log("newPatient", newPatient);
  const [form, setForm] = useState({
    PatientDetails: {
      PatientID: parseInt(Math.random() * 1000000000, 10),
      SessionID: uuidv4(),
      Branch: newPatient.PatientDetails.Branch
        ? newPatient.PatientDetails.Branch
        : authUser.Branch,
      FirstName: newPatient.PatientDetails.FirstName,
      LastName: newPatient.PatientDetails.LastName,
      Sex: newPatient.PatientDetails.Sex,
      IDNumber: newPatient.PatientDetails.IDNumber,
      PhoneNumber: newPatient.PatientDetails.PhoneNumber,
      Email: newPatient.PatientDetails.Email,
      DateOfBirthRaw: newPatient.PatientDetails.DateOfBirthRaw,
      DateOfBirthTimestamp: newPatient.PatientDetails.DateOfBirthTimestamp,
      Initials: newPatient.PatientDetails.Initials,
      Title: newPatient.PatientDetails.Title,
      Allergies: newPatient.PatientDetails.Allergies,
      PhysicalAddress: newPatient.PatientDetails.PhysicalAddress,
      PostalAddress: newPatient.PatientDetails.PostalAddress,
    },
    EmploymentDetails: {
      ContactPerson: newPatient.EmploymentDetails.ContactPerson,
      EmployerContactNumber: newPatient.EmploymentDetails.EmployerContactNumber,
      Occupation: newPatient.EmploymentDetails.Occupation,
      CompanyName: newPatient.EmploymentDetails.CompanyName,
      CompanyNumber: newPatient.EmploymentDetails.CompanyNumber,
      EmployerPhysicalAddress:
        newPatient.EmploymentDetails.EmployerPhysicalAddress,
      COIDRef: newPatient.EmploymentDetails.COIDRef,
      COIDEmployerName: newPatient.EmploymentDetails.COIDEmployerName,
      IncidentDate: newPatient.EmploymentDetails.IncidentDate,
      COIDEmployerRegNumber: newPatient.EmploymentDetails.COIDEmployerRegNumber,
      COIDEmployeeNumber: newPatient.EmploymentDetails.COIDEmployeeNumber,
    },
    MedicalAidDetails: {
      DependentCode: newPatient.MedicalAidDetails.DependentCode,
      MedicalAidMemberRelationToPatient:
        newPatient.MedicalAidDetails.MedicalAidMemberRelationToPatient,
      MedicalAidMemberFirstName:
        newPatient.MedicalAidDetails.MedicalAidMemberFirstName,
      MedicalAidMemberLastName:
        newPatient.MedicalAidDetails.MedicalAidMemberLastName,
      MedicalAidMemberIDNumber:
        newPatient.MedicalAidDetails.MedicalAidMemberIDNumber,
      MedicalAidMemberPhoneNumber:
        newPatient.MedicalAidDetails.MedicalAidMemberPhoneNumber,
      MedicalAidMemberPostalAddress:
        newPatient.MedicalAidDetails.MedicalAidMemberPostalAddress,
      MedicalAidName: newPatient.MedicalAidDetails.MedicalAidName,
      MedicalAidPlan: newPatient.MedicalAidDetails.MedicalAidPlan,
      MedicalAidNumber: newPatient.MedicalAidDetails.MedicalAidNumber,
      MedicalAidVatNumber: newPatient.MedicalAidDetails.MedicalAidVatNumber,
      MedicalAidMemberTitle: newPatient.MedicalAidDetails.MedicalAidMemberTitle,
      MedicalAidMemberInitials:
        newPatient.MedicalAidDetails.MedicalAidMemberInitials,
      MedicalAidMemberMemberEmployerName:
        newPatient.MedicalAidDetails.MedicalAidMemberMemberEmployerName,
      MedicalAidMemberMemberWorkDepartment:
        newPatient.MedicalAidDetails.MedicalAidMemberMemberWorkDepartment,
      MedicalAidMemberMemberOccupation:
        newPatient.MedicalAidDetails.MedicalAidMemberMemberOccupation,
      MedicalAidMemberMemberWorkPhone:
        newPatient.MedicalAidDetails.MedicalAidMemberMemberWorkPhone,
      MedicalAidMemberMemberWorkAddress:
        newPatient.MedicalAidDetails.MedicalAidMemberMemberWorkAddress,
    },
    Documents: EDITING_EXISTING_USER
      ? newPatient.Documents
      : {
          ID_DOC: null,
          MEDICAL_AID_DOC: null,
          REF_NOTE_DOC: null,
          OTHER_DOC_ONE: null,
          OTHER_DOC_TWO: null,
          OTHER_DOC_THREE: null,
          OTHER_DOC_FOUR: null,
          OTHER_DOC_FIVE: null,
          OTHER_DOC_SIX: null,
          OTHER_DOC_SEVEN: null,
          OTHER_DOC_EIGHT: null,
          OTHER_DOC_NINE: null,
        },
  });

  const [DOB, setDOB] = useState({
    DateOfBirthRaw: newPatient.DateOfBirthRaw
      ? newPatient.DateOfBirthRaw
      : new Date(),
    DateOfBirthTimestamp: newPatient.DateOfBirthTimestamp
      ? newPatient.DateOfBirthTimestamp
      : new Date().getTime(),
  });
  console.log("form", form);

  useEffect(() => {
    setForm({
      ...form,
      PatientDetails: {
        ...form.PatientDetails,
        DateOfBirthRaw: DOB.DateOfBirthRaw,
        DateOfBirthTimestamp: DOB.DateOfBirthTimestamp,
      },
    });
  }, [DOB]);

  useEffect(() => {
    if (
      form.MedicalAidDetails.MedicalAidMemberRelationToPatient === "SELF" &&
      form.MedicalAidDetails.MedicalAidMemberIDNumber !==
        form.PatientDetails.IDNumber
    ) {
      setForm({
        ...form,
        MedicalAidDetails: {
          ...form.MedicalAidDetails,
          MedicalAidMemberFirstName: form.PatientDetails.FirstName,
          MedicalAidMemberLastName: form.PatientDetails.LastName,
          MedicalAidMemberIDNumber: form.PatientDetails.IDNumber,
          MedicalAidMemberPhoneNumber: form.PatientDetails.PhoneNumber,
          MedicalAidMemberPostalAddress: form.PatientDetails.PostalAddress,
          MedicalAidMemberTitle: form.PatientDetails.Title,
          MedicalAidMemberInitials: form.PatientDetails.Initials,
          MedicalAidMemberMemberEmployerName:
            form.EmploymentDetails.ContactPerson,
          MedicalAidMemberMemberWorkDepartment:
            form.EmploymentDetails.Occupation,
          MedicalAidMemberMemberOccupation: form.EmploymentDetails.Occupation,
          MedicalAidMemberMemberWorkPhone: form.EmploymentDetails.CompanyNumber,
          MedicalAidMemberMemberWorkAddress:
            form.EmploymentDetails.EmployerPhysicalAddress,
        },
      });
    }
  }, [form]);

  const getCurrentForm = (step) => {
    switch (step) {
      case 1:
        return "PatientDetails";
      case 2:
        return "EmploymentDetails";
      case 3:
        return "MedicalAidDetails";
      case 4:
        return "Documents";
    }
  };
  //for medical; aid form
  const [disabled, setDisabled] = useState(false);
  //previous state for user to be able to undo when cash option
  // is clicked in medical name input
  const [prevFormState, setPrevFormState] = useState({});
  const handleMedicalAidSelect = (value, key, currentForm) => {
    console.log("value", value);
    if (value === "CASH/CARD") {
      setDisabled(true);

      const medicalAidFormKeys = Object.keys(form[currentForm]);

      var newMedDetails = {};
      for (let n in medicalAidFormKeys) {
        let mdk = medicalAidFormKeys[n];
        // console.log("mdk", mdk,value);

        newMedDetails = {
          ...newMedDetails,
          [mdk]:
            mdk === "DependentCode"
              ? 0
              : mdk !== "MedicalAidName"
              ? "null"
              : value,
        };
      }

      setForm({ ...form, [currentForm]: newMedDetails });
    } else {
      if (JSON.stringify(form) !== JSON.stringify(prevFormState)) {
        console.log("state set");
        setForm(prevFormState);
      } else {
        console.log("did not set state");
      }
      setDisabled(false);
    }
  };
  //###

  const handleChange = (event) => {
    const step = activeStep + 1;
    const _this = event.target;
    const key = _this.id;
    console.log("prev", prevFormState);
    const currentForm = getCurrentForm(step);
    if (key === "MedicalAidName") {
      handleMedicalAidSelect(_this.value, key, currentForm);
    }

    if (_this.value !== "CASH/CARD") {
      console.log("disabled is false");
      setForm({
        ...form,
        [currentForm]: {
          ...form[currentForm],
          [key]: _this.value,
        },
      });
      if (form[currentForm]["MedicalAidMemberFirstName"] !== "null") {
        setPrevFormState({
          ...form,
          [currentForm]: {
            ...form[currentForm],
            [key]: _this.value,
          },
        });
      }
    }
  };

  const handleChangeDate = (event) => {
    const step = activeStep + 1;
    const _this = event.target;
    const key = _this.id;

    const date1 = new Date(_this.value);
    const currentForm = getCurrentForm(step);

    setForm({
      ...form,
      [currentForm]: {
        ...form[currentForm],
        [key]: _this.value,
      },
    });
  };

  const handleBack = () =>
    setActiveStep((prevActiveStep) => prevActiveStep - 1);

  const handleReset = () => {
    setForm(INIT_CREATE_PATIENT_FORM_STATE);
    setActiveStep(0);
  };

  const handleNext = () => {
    const step = activeStep + 1;
    const currentForm = getCurrentForm(step);

    if (activeStep !== 3) {
      if (!formIsComplete(form[currentForm]) && false) {
        if (disabled) {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setDisabled(false);
          return;
        }
        props.enqueueSnackbar("Fill all required fields.", {
          preventDuplicate: true,
          variant: "warning",
        });
        return;
      }
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleSubmit = async () => {
    setSaving(true);

    if (!formIsComplete(form.MedicalAidDetails)) {
      props.enqueueSnackbar("Fill all required fields.", {
        preventDuplicate: true,
        variant: "warning",
      });
      setSaving(false);
      return;
    }

    newPatientDispatch(setNewPatient(form));

    try {
      let err;
      if (!EDITING_EXISTING_USER) {
        const [, error] = await createUser(form, "/patient");
        err = error;
      } else {
        console.log("Form",form)

        const [, error] = await editPatient(
          form.PatientDetails.IDNumber,
          form,
          "/patient/id"
        );
       err = error;
      }

      if (err) {
        props.enqueueSnackbar(err.message, {
          preventDuplicate: true,
          variant: "error",
        });
        setSaving(false);
      } else {
        setSaving(false);

        if (EDITING_EXISTING_USER) {
          props.enqueueSnackbar("Patient edited successfully", {
            preventDuplicate: true,
            variant: "success",
          });
          history.push("/worklist");
        } else {
          props.enqueueSnackbar("Patient created successfully", {
            preventDuplicate: true,
            variant: "success",
          });
          localStorage.setItem("current-patient", JSON.stringify(form));
          history.push("/study");
        }
      }
    } catch (err) {
      props.enqueueSnackbar(err.message, {
        preventDuplicate: true,
        variant: "error",
      });
      setSaving(false);
      console.log(err.message);
    }
  };

  console.log("form",form)
  return (
    <>
      <Helmet>
        <title>Create Patient</title>
      </Helmet>

      <Container style={{ padding: 20 }} maxWidth="md">
        <Stepper activeStep={activeStep}>
          {CREATE_PATIENT_STEPS.map((label) => {
            return (
              <Step key={label}>
                <StepLabel>
                  {" "}
                  <span style={{ fontSize: 12 }}> {label} </span>{" "}
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>

        {activeStep === CREATE_PATIENT_STEPS.length ? (
          <>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </>
        ) : (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
            style={{ display: "block" }}
          >
            <Box sx={{ mt: 2, mb: 1 }}>
              <form autoComplete={"false"}>
                {activeStep === 0 && (
                  <PatientDetailsForm
                    handleChange={handleChange}
                    setDOB={setDOB}
                    DOB={DOB}
                    form={form.PatientDetails}
                    branches={lists.branches}
                    allergies={lists.allergies}
                  />
                )}

                {activeStep === 1 && (
                  <EmploymentDetailsForm
                    handleChange={handleChange}
                    handleChangeDate={handleChangeDate}
                    form={form.EmploymentDetails}
                  />
                )}

                {activeStep === 2 && (
                  <MedicalAidDetailsForm
                    handleChange={handleChange}
                    handleChangeDate={handleChangeDate}
                    medicalAidNames={medicalAidNames}
                    form={form.MedicalAidDetails}
                    disabled={disabled}
                  />
                )}

                {activeStep === 3 && (
                  <DocumentsForm
                    handleChange={handleChange}
                    form={form.Documents}
                  />
                )}
              </form>
            </Box>

            <div
              style={{
                display: "flex",
                justifyContent:
                  activeStep === CREATE_PATIENT_STEPS.length - 1
                    ? "space-between"
                    : "flex-end",
                padding: 15,
                marginTop: 30,
              }}
            >
              {activeStep === CREATE_PATIENT_STEPS.length - 1 && (
                <Button
                  onClick={handleReset}
                  sx={{ mr: 2, opacity: 0 }}
                  color="primary"
                  size="large"
                >
                  Clear form
                </Button>
              )}

              <div style={{ display: "flex" }}>
                <Button
                  color="inherit"
                  size="large"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 2, color: "#fff" }}
                >
                  Back
                </Button>

                {activeStep === CREATE_PATIENT_STEPS.length - 1 ? (
                  <Button
                    onClick={handleSubmit}
                    color="secondary"
                    variant="contained"
                    size="large"
                    startIcon={<SaveIcon />}
                    disabled={isSaving}
                  >
                    {isSaving ? "Saving..." : "Save"}
                  </Button>
                ) : (
                  <Button
                    onClick={handleNext}
                    color="secondary"
                    variant="contained"
                    size="large"
                  >
                    Next
                  </Button>
                )}
              </div>
            </div>
          </Stack>
        )}
      </Container>
    </>
  );
}

export default withSnackbar(CreatePatient);
